angular.module('app.api').factory('CandidateApplicationApi', [
  'api',
  function CandidateApplicationApi(api) {
    const candidateApplicationApi = {
      getCandidateApplications: payload => {
        return api.get(`applications`, {params: payload})
      },
      getApplicationStages: async () => {
        return api.get('applications/stages')
      },
      getApplicationsCount: async id => {
        const result = await api.get(`applications/candidate/${id}/count`)

        return Number.parseInt(result.data, 10)
      },
    }
    return candidateApplicationApi
  },
])



// WEBPACK FOOTER //
// ./scripts/candidate-applications/candidate-application.api.js